import { FC } from 'react';
import GooglePlacesAutocomplete, {
  geocodeByPlaceId
} from 'react-google-places-autocomplete';
import { GOOGLE_MAP_API_KEY } from '../../api/baseURL';
import { showErrorToast } from '../../utils/toast';
import { colors } from '../colors';
import { Container, ErrorMessage, InputLabel } from '../input';

type IGooglePlace = {
  placeholder?: string;
  errorMessage?: string;
  className?: string;
  defaultInputValue?: string;
  label?: string;
  onSelect: (result: {
    state: string;
    address: string;
    lat: number;
    lng: number;
    city: string;
  }) => void;
};
export const GooglePlace: FC<IGooglePlace> = ({
  defaultInputValue,
  errorMessage,
  className,
  placeholder,
  onSelect,
  label
}) => {
  const handleSelected = async (data: {
    label: string;
    value: { place_id: string };
  }) => {
    const [res] = await geocodeByPlaceId(data.value.place_id);
    let geoState = '';
    for (let index = 0; index < res.address_components.length; index++) {
      const address = res.address_components[index];
      if (address.types[0] === 'administrative_area_level_1') {
        geoState = address.long_name;
        break;
      }
    }
    onSelect({
      address: data.label,
      city: res.address_components[0].long_name,
      lat: res.geometry.location.lat(),
      lng: res.geometry.location.lng(),
      state: geoState
    });
  };
  return (
    <Container className={className}>
      <InputLabel>{label}</InputLabel>
      <GooglePlacesAutocomplete
        apiKey={GOOGLE_MAP_API_KEY}
        apiOptions={{ region: 'NG' }}
        autocompletionRequest={{
          componentRestrictions: {
            country: ['ng']
          }
        }}
        onLoadFailed={(error: Error) => showErrorToast(error.message)}
        selectProps={{
          onChange: handleSelected,
          placeholder: placeholder,
          defaultInputValue: defaultInputValue,
          styles: {
            input: (provided: any) => ({
              ...provided,
              color: colors.textDark,
              padding: '8px 16px;',
              fontSize: 14
            }),
            control: (provided: any) => ({
              ...provided,
              background: colors.grey,
              borderRadius: 8,
              padding: 0,
              outline: 'transparent',
              border: `1px solid ${colors.greyText}`,
              marginTop: 6
            }),
            singleValue: (provided: any) => ({
              ...provided,
              color: colors.textDark,
              fontSize: 14,
              padding: 0
            })
          }
        }}
      />
      {!!errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}
    </Container>
  );
};
